@if (isLoading) {
	<div class="tw-flex tw-justify-center tw-items-center tw-h-screen">
		<mat-spinner></mat-spinner>
	</div>
} @else {
	<ea-session-timeout-modal></ea-session-timeout-modal>
	@if (siteRedesignEnabled && isNotificationsEnabled && !isWelcomeRoute) {
		<ea-notifications-slider class="aut-notification-slider"></ea-notifications-slider>
	}
	@if (!isWelcomeRoute) {
		<tu-navbar-top-header [productName]="constants.PRODUCTS.WORKFORCE_EDUCATION"></tu-navbar-top-header>
	}

	<main role="main" id="main-content">
		<ea-global-alerts></ea-global-alerts>
		<router-outlet></router-outlet>
	</main>
	@if (!isWelcomeRoute) {
		<ea-footer></ea-footer>
		<ea-external-navigation-modal></ea-external-navigation-modal>
	}
	@if (showEdMarketPlaceSurveyModal) {
		<tu-ed-market-place-survey-modal [participantId]="participantId"></tu-ed-market-place-survey-modal>
	}
}
